import React from 'react';
import { oneOf } from 'prop-types';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

// TODO: the keys may change based on API response, confirm with backend team
const statusBackgroundColors = {
  'Less Busy': 'secondary.medium',
  Normal: 'yellow.dark',
  Unknown: 'success.lighter',
  'Very Busy': 'graphic.dark',
};
// TODO: the keys may change based on API response, confirm with backend team
const statusTextColors = {
  'Less Busy': 'primary.dark',
  Normal: 'text.dark',
  Unknown: 'text.primary',
  'Very Busy': 'surface.white',
};

// TODO: the keys/status text may change based on API response, confirm with backend team
const TerminalStatusChip = ({ status = 'Unknown' }) => {
  const statusStyles = {
    '& span': {
      pb: 0.25,
      pl: 0.5,
      pr: 0,
      pt: 0.25,
    },
    '&::before': {
      backgroundColor: statusTextColors[status] ? `${statusTextColors[status]}` : '',
      borderRadius: '50%',
      content: '""',
      display: 'inline-block',
      height: 7,
      ml: 0.5,
      width: 7,
    },
    backgroundColor: statusBackgroundColors[status]
      ? `${statusBackgroundColors[status]}`
      : 'default.light',
    borderRadius: 0.5,
    color: statusTextColors[status] ? `${statusTextColors[status]}` : '',
    fontWeight: 600,
    height: 20,
    my: 1,
    px: 0.75,
    py: 1,
    textTransform: 'uppercase',
  };

  const getTooltipText = currentStatus => {
    return currentStatus === 'Unknown' ? 'Check with the terminal or TIMS' : null;
  };

  return (
    <Tooltip arrow title={getTooltipText(status)}>
      <Chip label={status} sx={statusStyles} />
    </Tooltip>
  );
};

TerminalStatusChip.propTypes = {
  // TODO: the keys/status text may change based on API response, confirm with backend team
  status: oneOf(['Less Busy', 'Normal', 'Very Busy', 'Unknown']).isRequired,
};

export default TerminalStatusChip;
